<p-dialog header="Formulario a adjuntar"
[modal]="true" 
[closable]="false"
[draggable]="false" 
[resizable]="false"
styleClass="p-dialog-firma-custom" 
[(visible)]="display"  
[style]="{ width: '800px' }">
    <p-messages [(value)]="messages" [enableService]="false"></p-messages>
    <app-attach-upload-file 
        [examenNumero]="this.examen?.id"
        [isRequire]="true"
        (filesAttachedData)="getAttachedFiles($event)"
        [viewMode]="'edit'"
        [esAunPorEnviar]="this.examen?.aunPorEnviar || false"
        [isRequire]=true
        [max]=1
        [lanzarAlert]=false>
    </app-attach-upload-file>
    <p-footer>
        <p-button (click)="closeModal()">Cancelar</p-button>
        <p-button (onClick)="cargarExamen()" *ngIf="!enviandose" [disabled]="deshabilitarBotonCargar()">Cargar</p-button>
        <p-button *ngIf="enviandose" disabled="true">Enviando...</p-button>
    </p-footer>
</p-dialog>